export const ITEM_MIN_HEIGHT = 36;
export const ITEM_BORDER_SIZE = 1;
export const ITEM_MIN_HEIGHT_WITH_BORDER = ITEM_MIN_HEIGHT + ITEM_BORDER_SIZE;
export const FOOTER_HEIGHT = 36;
